import React from "react";
import PropTypes from "prop-types";
import AddressInputComponent from '../input/AddressInputComponent';

class AddressComponent extends React.Component {

    constructor(props){
        super(props);
    }

    render(){
        const {data, metadata, userDataService, setFormState, userDataInit} = this.props;

        return (
            <div className="grid">
                <div className="grid__col-md-3 grid__col-sm-12">
                    Primary Work Address
                </div>
                <div className="grid__col-md-9 grid__col-sm-12">
                    <AddressInputComponent
                        data={data}
                        metadata={metadata}
                        userDataService={userDataService}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        required={true}
                    />
                </div>
            </div>
        );
    }
}

AddressComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.object.isRequired,
};

export default AddressComponent;